<template>
  <div class="options">
    <div 
      v-for="(optie, index) in opties"
      class="option"
      :key="id + '-' + index"
    >
      <input 
        type="radio" 
        :id="'question-' + id +'-answer-' + index" 
        @change="onChange($event)"
        :disabled="answer.answered"
          :name="id + '-question'"
          :value="optie.value" 
          class="input-hidden"
          :checked="answer.value === optie.value"
        />
        <label 
          class="hover-animation"
          :for="'question-' + id +'-answer-' + index" 
          > 
          <img :src="getImage(optie.image)" />
          <div class="question-label">{{optie.label}}</div>
          <div 
            v-if="answer.answered"
            class="feedback-icon"
            :class="[answer.answered ? correctAnswer === optie.value ? 'correct' : 'incorrect' : '']"
          >
          </div>
        </label>
      </div>
    </div>
</template>

<script>

let opties= [
  {
    label: 'ja',
    image: 'ja.png',
    value: 1,
  },
  {
    label: 'niet te zeggen',
    image: 'niet-te-zeggen.png',
    value: 2,
  },
  {
    label: 'nee',
    image: 'nee.png',
    value: 0,
  },  
]

import { reactive, watchEffect, toRefs } from 'vue';


export default {
	name: 'Opties',
  props: {
    id: Number,
    correctAnswer: {
      type: Number
    },
    answer: {
      type: Object,
      default() {
        return { }
      } 
    },
    onClick: {
      type: Function
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      opties: opties,
      correct: undefined
    })

    function getImage(name) {
      return require('@/assets/icons/' + name);
    }

    function onChange(event) {
      var number = +event.target.value;
    
      state.correct = props.correctAnswer === number;
      props.onClick({value: number, correct: state.correct});
    }

    return {
      ...toRefs(state),
      getImage,
      onChange
    }

  }
}
</script>


<style lang="scss">
  .options {
    display: flex;
    justify-content: space-between;

    background: $pale-pistachio;
    border-radius: 8px;
    padding-top: .5em;

    color: var(--stelling-color, #000);
    margin-top: 60px;

    @include sm { 
      justify-content: space-evenly;
    }

    .option {
      text-align: center;

      label {
        position: relative;
        cursor: pointer;
        // background: $pale-pistachio;
        padding-left: 1em;
        padding-right: 1em;
        border-radius: 8px;
        margin-top: -40px;

        &:hover {
          background: $pistachio;
        }
      }

      .feedback-icon {
        margin: 0 auto;
      }
    }

    input[type="radio"]:checked+label{
      background: $pistachio;
      transform: scale(1.2) rotate(-2deg);
      z-index: 10;
    } 

    input[type="radio"]:disabled+label{
      pointer-events: none;
    } 

    .question-label {
      text-align: center;
    }
  }

</style>